/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import translation from 'translation';

const initBeforeUnLoad = (showExitPrompt) => {
  const { t } = translation;
  window.onbeforeunload = null;
  (window.myTop || window).noPromptOnUnload = true;
  window.onbeforeunload = (event) => {
    if (showExitPrompt) {
      const e = event || window.event;
      e.preventDefault();

      if (e) {
        e.returnValue = t('comparison:haveNotSavedYourComparison');
      }
      // fireChangeRoute();
      return t('comparison:haveNotSavedYourComparison');
    }
  };
};
function useBeforeunload(bool, fireChangeRoute) {
  const [showExitPrompt, setShowExitPrompt] = useState(bool);

  window.onload = function () {
    initBeforeUnLoad(showExitPrompt, fireChangeRoute);
  };

  useEffect(() => {
    initBeforeUnLoad(showExitPrompt, fireChangeRoute);
  }, [showExitPrompt]);

  return [showExitPrompt, setShowExitPrompt];
}

export default useBeforeunload;
